/**
 * CollectionPage
 * Firestore-backed public listing for one content collection.
 */
import { useEffect, useState } from 'react';
import LoadingState from '../components/common/LoadingState';
import PublicContentCard from '../components/content/PublicContentCard';
import { listContent } from '../services/contentService';
import { getContentConfig } from '../utils/contentConfig';

export default function CollectionPage({ collectionKey }) {
  const config = getContentConfig(collectionKey);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let isSubscribed = true;

    async function loadCollection() {
      // Public pages only request published records.
      setLoading(true);
      setErrorMessage('');
      try {
        const result = await listContent(collectionKey, { publishedOnly: true });
        if (!isSubscribed) {
          return;
        }
        setItems(result);
      } catch (error) {
        if (!isSubscribed) {
          return;
        }
        setErrorMessage(error.message ?? 'Failed to load collection.');
      } finally {
        if (isSubscribed) {
          setLoading(false);
        }
      }
    }

    loadCollection();

    return () => {
      isSubscribed = false;
    };
  }, [collectionKey]);

  return (
    <div className="page-stack">
      <section className="section-heading">
        <div>
          <p className="eyebrow">Public Collection</p>
          <h1>{config?.title}</h1>
          <p>{config?.description}</p>
        </div>
      </section>

      {loading ? <LoadingState label={`Loading ${config?.title}...`} /> : null}
      {errorMessage ? <p className="form-error">{errorMessage}</p> : null}

      {!loading && !errorMessage ? (
        items.length === 0 ? (
          <div className="state-card">
            <p>No published records found.</p>
          </div>
        ) : (
          <div className="card-grid">
            {items.map((item) => (
              <PublicContentCard
                key={item.id}
                collectionKey={collectionKey}
                item={item}
                routeBase={config.route}
              />
            ))}
          </div>
        )
      ) : null}
    </div>
  );
}
